import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import type { ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel';
import { getTeacherListByCategoryIdAction } from '@/Module/Teacher/Store/Action/getTeacherListByCategoryIdAction';
import { categoryTeacherListSelectByCategoryId } from '@/Module/Teacher/Store/Selector';

export const useTeacherList = (id: ITeacherCategoryListCategory['id']) => {
  const dispatch = useAppDispatch();
  const categoryTeacher = useAppSelector(state => categoryTeacherListSelectByCategoryId(state, id));
  const { page, total, isLoading } = categoryTeacher ?? {};

  const hasMore = total ? total > (categoryTeacher?.teacherList?.ids?.length ?? 0) : false;

  useEffect(() => {
    if (!categoryTeacher) return () => {};

    const promise = dispatch(getTeacherListByCategoryIdAction(id));

    return () => {
      promise.abort();
    };
  }, [page, id]);

  return {
    isLoading,
    categoryTeacher,
    hasMore,
  };
};
